'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _mapCategories = require('./map-categories.html');

var _mapCategories2 = _interopRequireDefault(_mapCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _mapCategories2.default,
  bindings: {
    flex: '@',
    layout: '@'
  },
  controller: function () {
    function MapCategoriesComponent($mdDialog, $scope, MapCategoriesService, LoadingService, ToastService) {
      'ngInject';

      _classCallCheck(this, MapCategoriesComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        MapCategoriesService: MapCategoriesService,
        LoadingService: LoadingService,
        ToastService: ToastService
      });
    }

    _createClass(MapCategoriesComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.columns = [{
          FieldName: 'ProductName',
          DisplayName: 'Product Name'
        }, {
          FieldName: 'MapCount',
          DisplayName: 'Map Count'
        }];

        this.query = _extends({}, this.MapCategoriesService.getProductQuery());

        this.queryMapped = _extends({}, this.MapCategoriesService.getProductQuery());

        this.selectedProducts = [];
        this.selectedMappedProducts = [];
        this.mappedProducts = [];
        this.categories = [];
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var promises = [this.refreshProducts(), this.refreshMappedProducts()];

        Promise.all(promises);
      }
    }, {
      key: 'refreshProducts',
      value: function refreshProducts() {
        var _this = this;

        this.selectedProducts = [];
        this.selectedMappedProducts = [];

        var filter = (0, _odataFilterBuilder2.default)().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId).and(function (x) {
          return x.eq('IsMapped', 0);
        });

        if (this.productSearchText && this.productSearchText.length) {
          filter = filter.and(function (x) {
            return x.contains('ProductName', _this.productSearchText);
          });
        }

        this.promise = this.MapCategoriesService.searchProducts(_extends({}, this.query, {
          filter: filter
        }));

        return this.promise.then(function (r) {
          _this.products = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'refreshMappedProducts',
      value: function refreshMappedProducts() {
        var _this2 = this;

        this.selectedMappedProducts = [];

        var filter = (0, _odataFilterBuilder2.default)().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId).and(function (x) {
          return x.eq('IsMapped', 1);
        });

        if (this.mappedProductSearchText && this.mappedProductSearchText.length) {
          filter = filter.and(function (x) {
            return x.contains('ProductName', _this2.mappedProductSearchText);
          });
        }

        this.promiseMapped = this.MapCategoriesService.searchProducts(_extends({}, this.queryMapped, {
          filter: filter
        }));

        return this.promiseMapped.then(function (r) {
          _this2.mappedProducts = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'selectedCategoryChanged',
      value: function selectedCategoryChanged(_ref) {
        var selectedItem = _ref.selectedItem;

        this.selectedCategory = selectedItem;

        if (selectedItem) {
          this.refreshResults();
        } else {
          this.products = [];
          this.mappedProducts = [];
          this.productSearchText = null;
          this.mappedProductSearchText = null;
        }
      }
    }, {
      key: 'addMapping',
      value: function addMapping(selectedCategory, selectedProducts) {
        var _this3 = this;

        this.LoadingService.start();
        var productIds = selectedProducts.map(function (p) {
          return p.ProductId;
        });

        this.MapCategoriesService.addProductCategoryMapping(selectedCategory.ProductCategoryId, productIds).then(function () {
          _this3.selectedProducts = [];

          var promises = [_this3.refreshProducts(), _this3.refreshMappedProducts()];

          Promise.all(promises).then(function () {
            return _this3.ToastService.showSuccess('Product categories mapped successfully!');
          });
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        }).finally(function () {
          return _this3.LoadingService.stop();
        });
      }
    }, {
      key: 'removeMapping',
      value: function removeMapping(selectedCategory, selectedProducts) {
        var _this4 = this;

        this.LoadingService.start();
        var productIds = selectedProducts.map(function (p) {
          return p.ProductId;
        });

        this.MapCategoriesService.removeProductCategoryMapping(selectedCategory.ProductCategoryId, productIds).then(function () {
          _this4.selectedMappedProducts = [];

          var promises = [_this4.refreshProducts(), _this4.refreshMappedProducts()];

          Promise.all(promises).then(function () {
            return _this4.ToastService.showSuccess('Product categories unmapped successfully!');
          });
        }).catch(function (error) {
          return _this4.ToastService.showError(error);
        }).finally(function () {
          return _this4.LoadingService.stop();
        });
      }
    }, {
      key: 'onProductSearchTextChanged',
      value: function onProductSearchTextChanged(_ref2) {
        var searchText = _ref2.searchText;

        this.selectedProducts = [];
        this.productSearchText = searchText;
        this.refreshProducts();
      }
    }, {
      key: 'onQueryChanged',
      value: function onQueryChanged(_ref3) {
        var query = _ref3.query;

        this.selectedProducts = [];
        this.query = query;
        this.refreshProducts();
      }
    }, {
      key: 'onMappedProductSearchTextChanged',
      value: function onMappedProductSearchTextChanged(_ref4) {
        var searchText = _ref4.searchText;

        this.selectedMappedProducts = [];
        this.mappedProductSearchText = searchText;
        this.refreshMappedProducts();
      }
    }, {
      key: 'onMappedQueryChanged',
      value: function onMappedQueryChanged(_ref5) {
        var query = _ref5.query;

        this.selectedMappedProducts = [];
        this.queryMapped = query;
        this.refreshMappedProducts();
      }
    }]);

    return MapCategoriesComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.component.js